import Main from './pages/Main/Main'
import Blog from './pages/Blog/Blog'
import Article from './pages/Article/Article'
import { MAIN_ROUTE, BLOG_ROUTE, ARTICLE_ROUTE } from './utils/consts'

export const publicRoutes = [
  {
    path: MAIN_ROUTE,
    Component: Main
  },
  {
    path: BLOG_ROUTE,
    Component: Blog
  },
  {
    path: ARTICLE_ROUTE,
    Component: Article
  }
]
